import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import momentCN from 'moment/locale/zh-cn';
import { AccountInfoCN } from '../lang_modules/accountInfo';
import { analysisInfoCN } from "../lang_modules/analysisInfo";
import { downloadPortalCN } from "@/locales/lang_modules/downloadPortal";
import { myMainAnalysesCN } from "@/locales/lang_modules/myAnalyses";
import { mainResourcesCN } from "@/locales/lang_modules/resources";
import { dataAnalysisPageCN } from "@/locales/lang_modules/dataAnalysisPage";
import { buttonTextCN } from "@/locales/lang_modules/buttonText";
import { integrateLocalSamplesCN } from '@/locales/lang_modules/integrateLocalSamples';
import { importDataCN } from "@/locales/lang_modules/importData";

import { cellAnnotationCN } from '../lang_modules/cellAnnotation';
import { menuListCN } from "@/locales/lang_modules/menuList";

import { cellQualityCN } from '../lang_modules/cellQuality';
import { requestedDownloadsCN } from "@/locales/lang_modules/requestedDownloads";
import { tfRegulationCN } from "@/locales/lang_modules/TFResulation";
import { userCN } from "@/locales/lang_modules/user";
import { tutorialsCN } from "@/locales/lang_modules/tutorials";
import { integrateCN } from "@/locales/lang_modules/integrate";
import { productionCN } from "@/locales/lang_modules/production";
import { spatialIntegrateLocalDataCN } from '@/locales/lang_modules/spatialIntegrateLocalData';
import { simonCN } from "@/locales/lang_modules/simon";
import { ssoCN } from "@/locales/lang_modules/sso";
const components = {
  antLocale: zhLocale,
  momentName: 'zh-cn',
  momentLocale: momentCN,
};


// 公共操作
const commonOper = {
  'common.Input': '请输入',
  'common.Select': '请选择',
  'common.Required': '必填项',
  'common.Logout': '退出',
  'common.Email': '邮箱',
  'common.Apply': '应用',
  'common.Search': '搜索',
  'Common.Submit': '提交',
  "message.user.logOutTitle": '提示',
  'message.user.logOutMessage': '此操作將登出，是否继续？',
  "message.user.logOutConfirm": '确定',
  "message.user.logOutCancel": '取消',
  "message.user.logOutExit": '退出中',
  "message.login.signInText": '欢迎',
  'message.subscriptionText': '请申请更高权限，以获得更多功能权限 ',
  'message.login.expiredText': '登录状态已过期，请重新登录',
  'message.Undergoing.MaintenanceText': '网站正在维护中', // 网站正在维护中，请稍后尝试。
  'message.Undergoing.Later': '请稍后尝试。',
  'Common.SampleID': '样本ID',

  'Common.My.Data': '我的数据',
  'Common.Edit.Success': '修改成功',
  'Common.Subset.Regx.Tips': '名称不得包含空格、特殊符号或中文，且不得以数字和符号开头',
  'Common.Not.Exceed.Twenty.Length.Tips': '请勿超过20个字符',
  'Common.Not.Exceed.One.Hundred.Length.Tips': '任务名称请勿超过100个字符',
  'Common.Cluster.Regx.Tips': '名称不得包含特殊符号或中文，且不得以符号开头。',
  
  'Common.Cluster.Regx1.Tips': '名称不得包含特殊符号或中文，且不得以数字和符号开头。',
  'Common.SampleID.Regx.Tips': '样本ID不得包含空格、特殊符号或中文，且不得以数字和符号开头。',
  'Common.GroupName.Regx.Tips': '请输入分组名称，不得包含特殊符号或中文，且不得以数字和符号开头。',
  'Common.Group.Regx.Tips': '组分名称不得包含特殊符号或中文，且不得以数字和符号开头。',
  'Common.Group.Name.Not.Exceed.Twenty.Length.Tips': '分组名请勿超过20个字符。',
  'Common.Group.Category.Name.Not.Exceed.Twenty.Length.Tips': '组分名称请勿超过20个字符。',
};




export default {
  ...components,
  ...commonOper,
  ...AccountInfoCN,
  ...analysisInfoCN,
  ...downloadPortalCN,
  ...myMainAnalysesCN,
  ...mainResourcesCN,
  ...dataAnalysisPageCN,
  ...buttonTextCN,
  ...integrateLocalSamplesCN,
  ...cellAnnotationCN,
  ...importDataCN,
  ...menuListCN,
  ...cellQualityCN,
  ...requestedDownloadsCN,
  ...tfRegulationCN,
  ...userCN,
  ...tutorialsCN,
  ...integrateCN,
  ...productionCN,
  ...spatialIntegrateLocalDataCN,
  ...simonCN,
  ...ssoCN,
};
